import * as types from './types';

export const setLoading = ( type, loading ) => {
  return {
    type: types.SET_LOADING,
    payload: { [type]: loading }
  }
};

export const setPrizes = prizes => {
  return {
    type: types.SET_PRIZES,
    payload: prizes
  }
};

export const createPrize = prize => {
  return {
    type: types.CREATE_PRIZE,
    payload: prize
  }
};

export const updatePrize = ( id, prize ) => {
  return {
    type: types.UPDATE_PRIZE,
    payload: { id, prize }
  }
};

export const deletePrize = id => {
  return {
    type: types.DELETE_PRIZE,
    payload: id
  }
};

export const setTemplates = templates => {
  return {
    type: types.SET_TEMPLATES,
    payload: templates
  }
};

export const createTemplate = template => {
  return {
    type: types.CREATE_TEMPLATE,
    payload: template
  }
};

export const updateTemplate = ( id, template ) => {
  return {
    type: types.UPDATE_TEMPLATE,
    payload: { id, template }
  }
};

export const setStoreOpen = status => {
  return {
    type: types.SET_STORE_OPEN,
    payload: status
  }
};

export const updatePrizeLocally = ( id, updates ) => {
  return {
    type: types.UPDATE_PRIZE_LOCALLY,
    payload: { id, updates }
  };
};



// WEBPACK FOOTER //
// ./src/store/rewards/prizes/actions.js